import React, { useEffect, useState } from 'react'
import { PlayerData } from '../../metrics_server/players/types'
import { AddNewButton } from '../AddNewButton/AddNewButton'
import { Player } from '../Player/Player'
import Scroller from '../Scroller/Scroller'
import styles from './TeamGrid.module.scss'

export interface TeamGridProps {
  addPlayer?: () => void
  players: PlayerData[]
}

export const TeamGrid = (props: TeamGridProps) => {
  const { addPlayer, players } = props

  const [playersArr, setPlayersArr] = useState([])

  useEffect(() => {
    if (!players) return
    const newPlayersArr = players.map((player) => {
      return <Player key={player.id} id='player-card' player={player} />
    })
    setPlayersArr(newPlayersArr)
  }, [players, addPlayer])

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <Scroller scrollerClass='form-scroller'>
        <div className={styles.teamGridContainer}>
          <AddNewButton
            addCallBack={props.addPlayer}
            size={45}
            title={'Add Player'}
            horizontal={true}
          />
          {playersArr}
        </div>
      </Scroller>
    </div>
  )
}

export default TeamGrid
